export const FALLBACK_DEFAULT_CURRENCY = {
  code: "USD",
  displayName: "US Dollar",
  symbol: "$",
};
